<div class="genie-page">
  <!-- Page Header Section -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" (click)="builderService.navigateBack()">
        <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
      </div>
      <p class="genie-page-title">{{ 'Orders' | translate }}</p>
      <p class="genie-page-subtitle">{{ 'Manage product orders.' | translate }}</p>
    </div>
  </div>

  <!-- Orders Summary Cards -->
  <div class="orders-summary">
    <div class="order-card" [ngClass]="card.iconClass + '-card'" *ngFor="let card of orderSummary">
      <div class="icon" [ngClass]="card.iconClass">
        <img [src]="'assets/images/orders/' + card.icon" alt="{{ card.title }}" />
      </div>
      <div class="card-content">
        <div class="card-header-row">
          <p>{{ card.title | translate }}</p>
          <div class="card-count">
            <strong>{{ card.count }}</strong> {{ 'order' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Card -->
  <div class="genie-content-card">
    <!-- Empty State -->
    <div class="genie-empty-state" *ngIf="ordersService.paginationCount === 0 && !builderService.showUpdateProgress">
      <p class="no-orders">{{ 'There are no orders yet.' | translate }}</p>
    </div>

    <!-- Orders Table Section -->
    <div [hidden]="ordersService.paginationCount === 0 && !builderService.showUpdateProgress" class="table-section">
      <!-- Toolbar -->
      <div class="genie-toolbar">
        <div class="toolbar-left">
          <!-- Type Filter Dropdown -->
          <div class="filter-dropdown">
            <button class="filter-btn" (click)="toggleTypeDropdown($event)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 2.5L5.5 2.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 2.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 6H8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 6H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 9.5H5.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M3.5 9.5H1" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 10.5V8.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.5 3.5V1.5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.5 7V5" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ ordersService.selectedType === 'all' ? ('Filter by Type' | translate) : (ordersService.selectedType | titlecase) }}</span>
              <svg class="arrow" [class.open]="showTypeDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="dropdown-panel" *ngIf="showTypeDropdown">
              <div class="dropdown-options">
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'all'" (click)="selectType('all')">{{ 'All' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'pos'" (click)="selectType('pos')">{{ 'POS' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'menu'" (click)="selectType('menu')">{{ 'Menu' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'app'" (click)="selectType('app')">{{ 'App' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'website'" (click)="selectType('website')">{{ 'Website' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedType === 'social_agent'" (click)="selectType('social_agent')">{{ 'Social Agent' | translate }}</div>
              </div>
            </div>
          </div>

          <!-- Sort Dropdown -->
          <div class="filter-dropdown">
            <button class="filter-btn" (click)="toggleSortDropdown($event)">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 3H11M3 6H9M5 9H7" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ getSortLabel() }}</span>
              <svg class="arrow" [class.open]="showSortDropdown" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <div class="dropdown-panel" *ngIf="showSortDropdown">
              <div class="dropdown-options">
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'id_asc'" (click)="selectSort('id_asc')">{{ 'ID — ASC' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'id_desc'" (click)="selectSort('id_desc')">{{ 'ID — DESC' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'date_new'" (click)="selectSort('date_new')">{{ 'Date — Newest' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'date_old'" (click)="selectSort('date_old')">{{ 'Date — Oldest' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'total_high'" (click)="selectSort('total_high')">{{ 'Total — High → Low' | translate }}</div>
                <div class="dropdown-option" [class.selected]="ordersService.selectedSort === 'total_low'" (click)="selectSort('total_low')">{{ 'Total — Low → High' | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="toolbar-right">
          <!-- Mute Toggle -->
          <label class="bell-btn" [class.muted]="OrderNotification.getMuteState()" [matTooltip]="(OrderNotification.getMuteState() ? 'Unmute Notification Sound' : 'Mute Notification Sound') | translate">
            <input type="checkbox" [checked]="OrderNotification.getMuteState()" (change)="toggleMute($any($event.target).checked)" />
            <img src="assets/images/orders/notification.svg" class="bell-icon" alt="notification" />
          </label>

          <!-- Export to Excel Button -->
          <button class="genie-btn export" (click)="exportToExcel()">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.4375 7.4375C0.4375 9.0874 0.4375 9.91235 0.950063 10.4249C1.46263 10.9375 2.28758 10.9375 3.9375 10.9375H7.4375C9.0874 10.9375 9.91235 10.9375 10.4249 10.4249C10.9375 9.91235 10.9375 9.0874 10.9375 7.4375" stroke="currentColor" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.6888 0.4375V8.02083M5.6888 8.02083L8.02214 5.46875M5.6888 8.02083L3.35547 5.46875" stroke="currentColor" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {{ 'Export to Excel' | translate }}
          </button>
        </div>
      </div>

      <!-- Data Table -->
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th class="col-center">{{ 'id' | translate }}</th>
              <th class="col-center">{{ 'Date' | translate }}</th>
              <th>{{ 'User' | translate }}</th>
              <th class="col-center">{{ 'Source' | translate }}</th>
              <th class="col-center">{{ 'Total' | translate }}</th>
              <th class="col-center">{{ 'Status' | translate }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of displayedOrders">
              <td class="col-center">{{ order.humId || '-' }}</td>
              <td class="col-center">{{ order.date | date:'yyyy/MM/dd HH:mm:ss' }}</td>
              <td>{{ order.user_email || order.guestName || order.guestPhone || '-' }}</td>
              <td class="col-center">
                <span class="type-badge" [ngClass]="order.type?.toLowerCase()">{{ order.type | translate }}</span>
              </td>
              <td class="col-center">{{ order.total }}</td>
              <td class="col-center">
                <span class="genie-badge" [ngClass]="{
                  'success': order.status?.toLowerCase() === 'completed' || order.status?.toLowerCase() === 'complete' || order.status?.toLowerCase() === 'processing' || order.status?.toLowerCase() === 'received',
                  'warning': order.status?.toLowerCase() === 'pending' || order.status?.toLowerCase() === 'on-hold',
                  'danger': order.status?.toLowerCase() === 'cancelled' || order.status?.toLowerCase() === 'failed' || order.status?.toLowerCase() === 'refunded',
                  'info': order.status?.toLowerCase() === 'confirmed' || order.status?.toLowerCase() === 'shipped' || order.status?.toLowerCase() === 'in-transit',
                  'neutral': order.status?.toLowerCase() === 'draft' || order.status?.toLowerCase() === 'archived'
                }">{{ order.status | translate }}</span>
              </td>
              <td class="col-actions">
                <div class="genie-action-buttons">
                  <button
                    class="genie-icon-btn view"
                    (click)="editOrder(order.order_id)"
                    [matTooltip]="'View Order' | translate"
                  >
                    <svg width="18" height="18" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 2.8125C4.375 2.8125 1.75625 4.80625 0.625 7.5C1.75625 10.1937 4.375 12.1875 7.5 12.1875C10.625 12.1875 13.2437 10.1937 14.375 7.5C13.2437 4.80625 10.625 2.8125 7.5 2.8125Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M7.5 9.6875C8.70812 9.6875 9.6875 8.70812 9.6875 7.5C9.6875 6.29188 8.70812 5.3125 7.5 5.3125C6.29188 5.3125 5.3125 6.29188 5.3125 7.5C5.3125 8.70812 6.29188 9.6875 7.5 9.6875Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button
                    class="genie-icon-btn delete"
                    (click)="openDeleteModal(order)"
                    [matTooltip]="'Delete Order' | translate"
                  >
                    <svg width="18" height="18" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8.53438 3.13438V2.65438C8.53438 1.98231 8.53438 1.64628 8.40358 1.38959C8.28854 1.16379 8.10496 0.980215 7.87916 0.865167C7.62247 0.734375 7.28644 0.734375 6.61438 0.734375H5.65438C4.98231 0.734375 4.64628 0.734375 4.38959 0.865167C4.16379 0.980215 3.98022 1.16379 3.86517 1.38959C3.73438 1.64628 3.73438 1.98231 3.73438 2.65438V3.13438M4.93438 6.43438V9.43438M7.33438 6.43438V9.43438M0.734375 3.13438H11.5344M10.3344 3.13438V9.85438C10.3344 10.8625 10.3344 11.3665 10.1382 11.7516C9.96562 12.0903 9.69025 12.3656 9.35156 12.5382C8.96652 12.7344 8.46247 12.7344 7.45438 12.7344H4.81438C3.80628 12.7344 3.30223 12.7344 2.91719 12.5382C2.5785 12.3656 2.30314 12.0903 2.13056 11.7516C1.93437 11.3665 1.93438 10.8625 1.93438 9.85438V3.13438"
                        stroke="currentColor"
                        stroke-width="1.467"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Custom Pagination -->
      <div class="genie-pagination">
        <div class="pagination-pageSize">
          <span class="pageSize-label">{{ 'Items per page' | translate }}:</span>
          <select class="pageSize-select" [(ngModel)]="ordersService.pageSize" (change)="changePageSize(ordersService.pageSize)">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
        </div>
        <div class="pagination-info">
          <span class="current-page">{{ ordersService.pageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ getTotalPages() }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn prev" [disabled]="ordersService.pageIndex === 0" (click)="previousPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <button class="page-btn next" [disabled]="ordersService.pageIndex >= getTotalPages() - 1" (click)="nextPage()">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-delete-confirm-modal
  [visible]="showDeleteModal"
  [itemName]="'#' + orderToDeleteDisplayId"
  itemType="Order"
  (confirmed)="confirmDeleteOrder()"
  (cancelled)="closeDeleteModal()">
</app-delete-confirm-modal>
